// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_Htp","cls2":"ConfirmationModal-cls2_zws ConfirmationModal-cls1_Htp"};